import type { PropsWithChildren } from "react";
import { tw } from "src/design-system/tw";

export function PromoGallery({
  listLength = 3,
  children,
}: PropsWithChildren<{ listLength?: number }>) {
  const gridColsClass =
    {
      1: "md:grid-cols-1",
      2: "md:grid-cols-2",
      3: "md:grid-cols-3",
    }[listLength] || "md:grid-cols-3";

  return (
    <div
      className={tw(
        "-mx-4 scrollbar-hidden flex snap-x snap-mandatory gap-3 overflow-x-auto px-4 md:grid",
        gridColsClass,
      )}
    >
      {children}
    </div>
  );
}
